import { useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import ChartQueryBuilder from "components/common/ChartQueryBuilder/ChartQueryBuilder";
import { useAccountingLogics } from "./useAccountingLogics";

const Accounting = () => { 
  const { fetchAccounting, accountingData, stateB } = useAccountingLogics();

  useEffect(() => {
    fetchAccounting();
  }, []);

  return (
    <div>
      <ChartQueryBuilder
        chartName={"accountChart"}
        siteType={"admin"}
        accountingData={accountingData}
        refetch={fetchAccounting}
      >
        <div style={{ marginTop: "1.5rem" }}>
          <ReactApexChart
            options={stateB?.options}
            series={stateB.series}
            type="bar"
            height={350}
          />
        </div>
      </ChartQueryBuilder>
    </div>
  );
};

export default Accounting;
